import type { IconSvgObject } from './types';

const PieChartIcon: IconSvgObject = [
  ["path", { d: "M20.5 15.8278C17.9985 21.756 9.86407 23.4835 5.20143 18.8641C0.629484 14.3347 2.04493 6.12883 8.05653 3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.4718 12.5C21.671 9.85979 20.82 7.13848 18.7986 5.13585C16.7723 3.12841 14.0904 2.31961 11.5 2.5333V12.5H21.4718Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PieChartIcon;
